module.exports = __webpack_public_path__ + "static/media/ty.583b121d.png";